<template>
  <v-layout>
    <v-dialog
      v-if="isShow"
      v-model="isShow"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.resetPass`) }}
          <b>{{ Account.obj.name }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn tile color="primary" @click="_fnResetPass()">
            {{ $t(`table.agree`) }}
          </v-btn>
          <v-btn tile outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  model: {
    prop: "isShow",
    event: "change",
  },
  props: {
    isShow: Boolean,
  },
  data: () => ({
    model: "Account",
  }),
  methods: {
    _fnReset() {
      this.$emit("change", false);
    },
    async _fnResetPass() {
      const { code } = await this.fnPut({
        url: `/v1/admin/account/resetpass/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReset();
      }
    },
  },
};
</script>
